import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// analytics
Vue.use(VueAnalytics, {
  id: 'UA-44722268-1',
  router,
  // track only in production mode
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})
